import axios from "axios";
import { API_HOST } from "@/core/variables";


class NLURepository {
    getNLUAgents = async () => {
        return axios
            .get(`${API_HOST}/agents`, {
                params: {
                    limit: 10000,
                    active: true
                }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    getAutocompletes = async (agentToken: string) => {
        return axios
            .get(`${API_HOST}/agents/autocompletetokens`, {
                params: {
                    agent_token: agentToken
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
}

const nluRepository = new NLURepository();

export default nluRepository;
